import { useState, useEffect } from "react";
import { useLocalization } from "@fluent/react";
import ApiHttp from "byzantine/src/ApiHttp";
import { ScrollingIframe } from "cerulean";

interface SignedUrlIframeProps {
  endpoint: string;
  height?: string;
  setLoading?: (loading: boolean) => void;
  setError?: (error: any) => void;
  sendNotification?: (notification: any) => void;
  endpointIsUrl?: boolean;
  sandbox?: string;
}

export default function SignedUrlIframe({
  endpoint,
  height = "600px",
  setLoading = () => {},
  setError = () => {},
  sendNotification,
  endpointIsUrl,
  sandbox,
}: SignedUrlIframeProps) {
  const { l10n } = useLocalization();
  const [src, setSrc] = useState("");
  const [action, setAction] = useState("");
  const [signedRequest, setSignedRequest] = useState("");
  const [postBody, setPostBody] = useState("");
  const [postBodyParameterName, setPostBodyParameterName] = useState("");
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      setLoading(true);

      try {
        const response = await ApiHttp.fetch(endpoint, { endpointIsUrl });

        if (response.method === "post") {
          setAction(response.url);
          setSignedRequest(response.signed_request || "");
          setPostBody(response.post_body || "");
          setPostBodyParameterName(
            response.post_body_parameter_name ||
              (response.post_body ? "post_body" : "")
          );
          setCode(
            response.post_body ? "" : new URL(response.url).searchParams.get("code")
          );
        } else {
          setSrc(response.url);
          setCode("");
        }
      } catch (err) {
        setCode("");
        setError(err);

        if (sendNotification) {
          sendNotification({
            type: "negative",
            text: l10n.getString(
              "error-external-service-unavailable",
              null,
              "Sorry, this external service is not available at this time"
            ),
          });
        }
      }

      setLoading(false);
    };

    fetchSignedUrl();
  }, []);

  if (code === null) {
    return null;
  }

  return (
    <ScrollingIframe
      title="signedUrl"
      height={height}
      src={src}
      action={action}
      signedRequest={signedRequest}
      postBody={postBody}
      postBodyParameterName={postBodyParameterName}
      code={code}
      sandbox={sandbox}
    />
  );
}
